module.exports = __webpack_public_path__ + "img/comercializacion.b305b97b.png";